import db from './dbConfig';
import { loadStripe } from '@stripe/stripe-js';
import firebase from './config';
import 'firebase/functions'

export async function Assinar(uid) {

  const price = 'price_1Qs61nG4is0g20B3MaDpHjPO'

  const checkoutSessionRef = await db
    .collection('users')
    .doc(uid)
    .collection('checkout_sessions')
    .add({
      price: price,
      allow_promotion_codes: true,
      success_url: `${window.location.origin}/profile`,
      cancel_url: `${window.location.origin}/upgrade`,
      mode: 'subscription'
    });

  checkoutSessionRef.onSnapshot((snap) => {
    const { error, url } = snap.data();
    if (error) {
      // Show an error to your customer and
      // inspect your Cloud Function logs in the Firebase console.
      alert(`An error occured: ${error.message}`);
    }
    if (url) {
      // We have a Stripe Checkout URL, let's redirect.
      window.location.assign(url);
    }
  })
}